import { Link } from 'react-router-dom'
import { StyledText } from '../styled'

interface MenuProps {
  label: string
  path: string
}

export const Menu = ({ label, path }: MenuProps) => {
  return (
    <Link to={path}>
      <StyledText color="white">{label}</StyledText>
    </Link>
  )
}
